
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/undertoy",
      function () {
        return require("private-next-pages/sexleketoy/undertoy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/undertoy"])
      });
    }
  